import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

import {
  Chip as BaseChip,
  SmallBodySemiBold,
  TextWithTooltip as BaseTextWithTooltip
} from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { generateShiftName } from '@ubeya/shared/utils/scheduling';

const Chip = styled(BaseChip)`
  cursor: ${({ onClick }) => onClick && 'pointer'};
  max-width: 100%;
`;

const TextWithTooltip = styled(BaseTextWithTooltip)`
  max-width: 100%;
`;

const ShiftRenderer = ({
  rowData,
  columnData: { accountId, mappedLabels, mappedJobTypes, mappedLocations, mappedPtoTypes }
}) => {
  const {
    summarized,
    shift,
    labelId,
    jobTypeId,
    isJob,
    isPto,
    isLeave,
    ptoType,
    branchId,
    projectId,
    shiftLabel = '',
    shiftId
  } = rowData;
  const { t } = useContext(ConfigContext);

  const link = useMemo(
    () => projectId && shiftId && `${accountId}/scheduling/branch/${branchId}/project/${projectId}?shiftId=${shiftId}`,
    [accountId, branchId, projectId, shiftId]
  );

  if (summarized) {
    return (
      <SmallBodySemiBold>
        {shift} {t('shifts')}
      </SmallBodySemiBold>
    );
  }

  const label = (
    <TextWithTooltip>
      {shiftLabel || generateShiftName(rowData, mappedJobTypes, mappedLabels, mappedLocations, mappedPtoTypes)}
    </TextWithTooltip>
  );

  const background = isJob
    ? mappedJobTypes[jobTypeId]?.background
    : isPto
    ? mappedPtoTypes[ptoType]?.background
    : isLeave
    ? undefined
    : mappedLabels[labelId]?.background;

  const color = isJob
    ? mappedJobTypes[jobTypeId]?.color
    : isPto
    ? mappedPtoTypes[ptoType]?.color
    : isLeave
    ? undefined
    : mappedLabels[labelId]?.color;

  return (
    <Chip
      onClick={link ? () => window.open(link, '_blank') : undefined}
      label={label}
      background={background}
      color={color}
    />
  );
};

export default ShiftRenderer;
